import { useState } from "react";
import { useDispatch } from "react-redux";
import { generatePath, useNavigate } from "react-router-dom";
import { Path } from "app/path";
import { updateCart } from "app/redux/cartSlice";
import { DualPricingPaymentTypes } from "../useBook";

// Shared "last mile" of booking: once a cart has merchant services and a start
// time, either collect the dual-pricing payment method or go straight to checkout.
export const useOrderFinalizer = ({
  nameKey,
  shopKey,
  account,
  query,
}: {
  nameKey: string | undefined;
  shopKey: string | undefined;
  account: any;
  query: URLSearchParams;
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showDualPricingModal, setShowDualPricingModal] = useState(false);

  const navigateToOrderUrl = (dualPricingMethod?: DualPricingPaymentTypes) => {
    if (dualPricingMethod) {
      query.set("dualPricingMethod", dualPricingMethod);
    }
    const orderUrl = generatePath(Path.ORDER, { nameKey, shopKey } as any);
    navigate(`${orderUrl}?${query.toString()}`);
  };

  const onDualPricingPayBy = (method: DualPricingPaymentTypes) => {
    switch (method) {
      case DualPricingPaymentTypes.CARD:
        navigateToOrderUrl(DualPricingPaymentTypes.CARD);
        break;
      case DualPricingPaymentTypes.CASH:
        navigateToOrderUrl(DualPricingPaymentTypes.CASH);
        break;
      default:
        return;
    }
  };

  const finalizeCartWithTime = async ({
    cartUid,
    startTime,
  }: {
    cartUid: string | null;
    startTime: string;
  }) => {
    await dispatch(updateCart({ uid: cartUid, startTime } as any) as any);

    navigateToOrderUrl();
  };

  return {
    showDualPricingModal,
    setShowDualPricingModal,
    onDualPricingPayBy,
    navigateToOrderUrl,
    finalizeCartWithTime,
  };
};
